import commonConstants from "./commonConstants";

const tabletConstants = {
  ...commonConstants,
} as const;

export default tabletConstants;
